"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paletteConfigToInteractableTokens = paletteConfigToInteractableTokens;
var _paletteValueToInteractableToken = require("./paletteValueToInteractableToken");
function paletteConfigToInteractableTokens({
  paletteConfig,
  spectrum,
  isWeb
}) {
  // Object.keys + reduce is more performant than for/of loop https://jsbench.me/uhkyu88ggg/1
  return Object.keys(paletteConfig).reduce((acc, paletteAlias) => {
    const paletteValue = paletteConfig[paletteAlias];
    acc[paletteAlias] = (0, _paletteValueToInteractableToken.paletteValueToInteractableToken)({
      paletteValue,
      options: {
        paletteConfig,
        spectrum,
        isWeb
      }
    });
    return acc;
  }, {});
}